// Token offset decoding utility
// Separate file to avoid circular dependencies
const TOKEN_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const TOKEN_OFFSET = 5;

export const decodeOffsetToken = (encoded: string): string => {
    if (!encoded) return '';
    const len = TOKEN_ALPHABET.length;
    return encoded.split('').map(ch => {
        const idx = TOKEN_ALPHABET.indexOf(ch);
        return idx === -1 ? ch : TOKEN_ALPHABET[(idx - TOKEN_OFFSET + len) % len];
    }).join('');
};

export const encodeOffsetToken = (plain: string): string => {
    if (!plain) return '';
    const len = TOKEN_ALPHABET.length;
    return plain.split('').map(ch => {
        const idx = TOKEN_ALPHABET.indexOf(ch);
        return idx === -1 ? ch : TOKEN_ALPHABET[(idx + TOKEN_OFFSET) % len];
    }).join('');
};


/**
 * Wait for token(s) to be available in localStorage
 * Checks localStorage directly to avoid circular dependencies
 * @param tokenKeys 
 * @param timeout 
 * @returns 
 */
export const waitForAllTokens = async (tokenKeys: string | string[], timeout: number | null = null): Promise<boolean> => {
    // Handle null or empty cases
    if (!tokenKeys) return true;

    // Convert single token key to array
    const tokens = Array.isArray(tokenKeys) ? tokenKeys : [tokenKeys];

    const checkTokens = () => {
        return tokens.every(tokenKey => {
            // Check if encrypted token exists in localStorage
            const encryptedToken = localStorage.getItem(tokenKey);
            return encryptedToken !== null && encryptedToken !== undefined;
        });
    };

    // If all tokens are already available, return immediately
    if (checkTokens()) return true;

    // If no timeout, wait indefinitely
    if (timeout === null) {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (checkTokens()) {
                    clearInterval(interval);
                    resolve(true);
                }
            }, 100); // Check every 100ms
        });
    }

    // With timeout
    const startTime = Date.now();
    return new Promise((resolve) => {
        const interval = setInterval(() => {
            if (checkTokens()) {
                clearInterval(interval);
                resolve(true);
            } else if (Date.now() - startTime >= timeout) {
                clearInterval(interval);
                resolve(false);
            }
        }, 100); // Check every 100ms
    });
};
